var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"four-zero-four"},[_c('div',{staticClass:"four-zero-four-container"},[_c('div',{staticClass:"error-code"},[_vm._v("404")]),_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t('lisa_web_page_not_found')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }